var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 642,
    height: 311,
    viewBox: "0 0 642 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.679 71.6645C541.252 88.7588 604.388 81.8006 631.635 76.1848C612.389 79.4781 568.882 83.86 548.816 75.0418C528.75 66.2236 389.892 30.9592 322.971 14.4292L313.927 14.8517C316.82 23.6702 346.762 31.8601 361.372 34.8527C395.403 40.0006 472.107 54.5702 506.679 71.6645Z",
    fill: "url(#paint0_linear_723_840)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M636.969 215.92L632.236 253.02C548.126 270.179 523.07 267.679 517.736 262.416C458.204 229.782 447.095 200.289 448.982 189.621C451.699 181.42 468.617 170.83 514.544 194.076C560.471 217.322 615.297 218.324 636.969 215.92Z",
    fill: "url(#paint1_linear_723_840)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2363 300.52L263.762 299.168C304.317 297.274 306.787 279.006 302.952 270.109C297.713 261.779 271.827 244.101 210.195 240.03C148.563 235.96 102.023 208.444 86.4572 195.195C74.0056 185.643 45.1549 166.789 29.3642 167.794C13.5736 168.798 8.03562 179.258 7.24046 184.362L19.7363 277.02C22.2071 289.066 47.4085 300.728 54.2363 300.52Z",
    fill: "url(#paint2_linear_723_840)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M537.667 96.7774L508.918 65.0451L563.332 62.5035L537.667 96.7774Z",
    fill: "#F68500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1461 221.709L44.3977 189.977L98.8114 187.435L73.1461 221.709Z",
    fill: "#F68500"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_723_840",
    x1: 474.726,
    y1: 87.1521,
    x2: 471.006,
    y2: 7.5147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_723_840",
    x1: 472.877,
    y1: 205.878,
    x2: 626.959,
    y2: 245.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_723_840",
    x1: 173.6,
    y1: 294.025,
    x2: 56.6478,
    y2: 158.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A00CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientCard1);
export default __webpack_public_path__ + "static/media/gradient-card-1.78b76f877250bf13988d9e4976b42555.svg";
export { ForwardRef as ReactComponent };